import { render, staticRenderFns } from "./ModalDocumentos.vue?vue&type=template&id=4e606275&scoped=true&"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ModalDocumentos.vue?vue&type=style&index=0&id=4e606275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e606275",
  null
  
)

export default component.exports